import { render, staticRenderFns } from "./DiscountCard.vue?vue&type=template&id=397a9cb0&scoped=true&"
import script from "./DiscountCard.vue?vue&type=script&lang=js&"
export * from "./DiscountCard.vue?vue&type=script&lang=js&"
import style0 from "./DiscountCard.vue?vue&type=style&index=0&id=397a9cb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397a9cb0",
  null
  
)

export default component.exports